import { DomainFormSchema } from "@/schemas/domain-form.schema";
import { cbHttp } from "./http.service";
import { z } from "zod";
import { DomainSchema } from "@/schemas/domain.schema";


export const addDomain = async (companyId: string, data: z.infer<typeof DomainFormSchema>): Promise<z.infer<typeof DomainSchema>> => {
    return cbHttp.post(`/api/companies/domains/${companyId}`, data);
}

export const getDomainById = async (domainId: string): Promise<z.infer<typeof DomainSchema>> => {
    return cbHttp.get(`/api/domains/${domainId}`);
}

export const getAllDomains = async (): Promise<z.infer<typeof DomainSchema>[]> => {
    return cbHttp.get("/api/domains/domains");
}

export const getNormalDomains = async (): Promise<z.infer<typeof DomainSchema>[]> => {
    return cbHttp.get("/api/domains/normaldomains");
}

export const getPermaDeleteDomains = async (): Promise<z.infer<typeof DomainSchema>[]> => {
    return cbHttp.get("/api/domains/permadeletedomains");
}

export const connectionCheckDomain = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/domains/testdomainconnection", data);
}

export const updateBackupLimit = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/domains/updatebackuplimit", data);
} 

export const getRequisitionDomains = async(): Promise<z.infer<typeof DomainSchema>[]> => {
    return cbHttp.get("/api/domains/requisitiondomains");
}